import { ThemeProvider as ThemeProviderBase } from 'styled-components';

import { Theme } from '../types';

type Props = {
  /**
   * @note
   * You can use `createTheme` to generate theme
   */
  theme: Theme;
};

const ThemeProvider: React.FC<React.PropsWithChildren<Props>> = ({
  theme,
  children,
}) => <ThemeProviderBase theme={theme}>{children}</ThemeProviderBase>;

export default ThemeProvider;
